import {
  AbiRegistry,
  ProxyNetworkProvider,
  SmartContractController
} from '@multiversx/sdk-core/out';
import json from 'ping-pong.abi.json';

export const abi = AbiRegistry.create(json);

export const getScController = (network: {
  chainId: string;
  apiAddress: string;
}) =>
  new SmartContractController({
    chainID: network.chainId,
    networkProvider: new ProxyNetworkProvider(network.apiAddress),
    abi
  });
